import { useContext } from 'react';
import { productContext } from "../../context";
export var useProduct = function useProduct() {
  return useContext(productContext);
};
//# sourceMappingURL=useProduct.js.map